import React from 'react';

export type Icons = 'add' | 'arrow_back' | 'call_to_action' | 'cup' | 'delete' | 'error_outline'
  | 'help' | 'images' | 'list' | 'menu' | 'more_vert' | 'notes' | 'settings'
  | 'theme' | 'video' | 'content_copy' | 'flag' | 'medal' | 'clipboard'
  | 'stopwatch' | 'user_check' | 'checkmark' | 'hour_glass';

type Props = {
  className?: string;
  icon: Icons;
  size?: 'small' | 'default' | 'large';
};

const Icon:React.FC<Props> = ({
  // Props
  className = '', icon, size = 'default'
}) => {
  return (
    <span className={`
      ${className}
      flex justify-center items-center
      ${size === 'small' ? 'w-4 h-4 text-base leading-4' : size === 'large' ? 'w-7 h-7 text-3xl leading-7' : 'w-6 h-6 text-2xl leading-6'}
    `}>
      <i className={`icon icon-${icon}`}></i>
    </span>
  )
}

export default Icon;
